import request from '@/utils/request'
class Adv {
    //广告
    list(params) {
        return request({
            url: '/api/micro-website/v1/ad/index',
            method: 'get',
            data: params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            }
        })
    }
	//内容分类
	navbar(params) {
	    return request({
	        url: '/api/micro-website/v1/navbar/index',
	        method: 'get',
	        data: params,
	        headers: {
	            'Content-Type': 'application/json;charset=UTF-8'
	        }
	    })
	}
	//分类带内容列表
	cate(params) {
	    return request({
	        url: '/api/micro-website/v1/navbar/cate-news',
	        method: 'get',
	        data: params,
	        headers: {
	            'Content-Type': 'application/json;charset=UTF-8'
	        }
	    })
	}
	//内容列表
	navList(params) {
	    return request({
	        url: '/api/micro-website/v1/navbar/item-detail',
	        method: 'get',
	        data: params,
	        headers: {
	            'Content-Type': 'application/json;charset=UTF-8'
	        }
	    })
	}
	//内容详情
	detail(params) {
	    return request({
	        url: '/api/micro-website/v1/navbar/item-detail-data',
	        method: 'get',
	        data: params,
	        headers: {
	            'Content-Type': 'application/json;charset=UTF-8'
	        }
	    })
	}
	//广告详情
	adDetail(params) {
	    return request({
	        url: '/api/micro-website/v1/ad/detail',
	        method: 'get',
	        data: params,
	        headers: {
	            'Content-Type': 'application/json;charset=UTF-8'
	        }
	    })
	}
    
};
export {
    Adv
};